import * as React from "react";
import { cs } from "../../core/classSet";
import styles from "./Button.module.css";

export type BtnStyle = "solid" | "outline";

export interface IButtonProps {
  blurOnClick?: boolean;
  btnStyle?: BtnStyle;
  children?: React.ReactNode;
  disabled?: boolean;
  floating?: boolean;
  fullWidth?: boolean;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  bigLineHeight?: boolean;
  onClick?: (ev: React.MouseEvent<HTMLElement>) => any;
}

export default function Button({
  blurOnClick,
  btnStyle = "solid",
  children,
  disabled,
  floating,
  fullWidth,
  iconLeft,
  iconRight,
  bigLineHeight,
  type = "button",
  onClick,
}: IButtonProps) {
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  function getStyleClassName() {
    if (btnStyle === "outline" && disabled) {
      return styles.outlineDisabled;
    }

    if (btnStyle === "outline") {
      return styles.outline;
    }

    if (disabled) {
      return styles.solidDisabled;
    }

    return styles.solid;
  }

  const styleClassName = getStyleClassName();

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (...args) => {
    onClick?.(...args);

    if (!blurOnClick) {
      return;
    }

    const node = buttonRef.current;

    if (node) {
      node.blur();
    }
  };

  return (
    <button
      className={cs(
        styleClassName,
        fullWidth && styles.fullWidth,
        floating && styles.floating,
        bigLineHeight && styles.bigLineHeight,
      )}
      ref={buttonRef}
      // we know the type is a string, despite eslint complaining
      // eslint-disable-next-line react/button-has-type
      type={type}
      onClick={handleClick}
    >
      {!!iconLeft && <div className={styles.iconLeft}>{iconLeft}</div>}
      {children}
      {!!iconRight && <div className={styles.iconRight}>{iconRight}</div>}
    </button>
  );
}
